document.addEventListener('alpine:init', () => {
  Alpine.data('navigation', () => ({
    init () {
      this.logger('Initialising section')

      /**
       * Lock body scroll on open - keeps the main page from scrolling when scrolling on mobile menu
       */
      this.$watch('isMobileMenuActive', isActive => {
        if (isActive) document.body.style.overflow = 'hidden'
        else document.body.style.overflow = 'unset'
      })

      /**
       * Close mobile menu when cart is opened (can be removed if not needed)
       */
      Alpine.effect(() => {
        const isCartActive = Alpine.store('cart').isActive
        if (isCartActive) this.isMobileMenuActive = false
      })

      /**
       * Check if we should animate the menu - only when one of the states === false
       */
      this.$watch('currentMegaMenu', (current, previous) => {
        if (!!current && !!previous) this.shouldAnimateMenu = false
        else this.shouldAnimateMenu = true
      })
    },
    /**
     * Simple logger that uses the `debug` to be default hide messages on the console, and prefixes all messages with the current
     * Alpine data/store context.
     *
     * @param {...*} messages
     */
    logger (...messages) {
      console.debug('[Navigation]', ...messages)
    },

    // State

    /** Mobile menu active state @type {boolean} */
    isMobileMenuActive: false,

    /** The currently opened mobile child menu @type {string|null} */
    currentMobileChildMenu: null,

    /** Current active mega menu @type {string|null} */
    currentMegaMenu: null,

    /**
     * Whether we should enable the menu transition - should only be enabled when entering/exiting the mega menu associated area.
     * @type {boolean}
     */
    shouldAnimateMenu: true,

    // Methods

    /**
     * Toggle whether the mobile menu is active or not.
     *
     * @param {boolean} state
     */
    toggleMobileMenu (state) {
      this.currentMobileChildMenu = null

      if (typeof value === 'boolean') this.isMobileMenuActive = value
      else this.isMobileMenuActive = !this.isMobileMenuActive
    },

    /**
     * Toggle a mobile child menu - i.e. the 'Shop Women' sub menu.
     *
     * @param {string} id
     * @param {boolean} [state]
     */
    toggleMobileChildMenu (id, state) {
      const isCurrent = this.currentMobileChildMenu === id

      if (typeof state === 'boolean') this.currentMobileChildMenu = state ? id : null
      else this.currentMobileChildMenu = isCurrent ? null : id
    },

    /**
     * Set a mega menu as the currently active menu.
     * This is called from a `@mouseenter` Alpine event.
     *
     * @param {string} [id]
     */
    setActiveMegaMenu (id) {
      if (id) this.currentMegaMenu = id
    },

    /**
     * Conditionally close a mega menu by setting the active menu to null - we call this from a `@mouseleave` Alpine event.
     *
     * This will _only_ set it to null if the element the mouse entered/exited was **not** a mega-menu associated item.
     * This is because we want to disable the menu transition if we move from one menu to another, and otherwise this would get called
     * exiting the first menu, and then subsequently the `setActiveMegaMenu` method would be called, leading to the `currentMegaMenu`
     * being `null` in between these states, which in turn leads to the transition being enabled. So doing it as the below means if we move
     * from one mega menu to another, the `currentMegaMenu` is never `null` in between, meaning the transition is disabled.
     *
     * @param {PointerEvent} event
     */
    closeMegaMenu (event) {
      if (!event || event.type !== 'mouseleave') {
        this.logger('Passed an invalid event type to `closeMegaMenu`,', ...(event ? [`Should be 'mouseleave', but got '${ event.type }'`] : []))
        return
      }

      const closestNavMenu = event.toElement && event.toElement.closest('.navigation-menu')
      const closestNavItem = event.toElement && event.toElement.closest('.navigation-menu-container')

      // Check if the element we moved to has a block ID (i.e. we are on a mega menu associated item)
      const toId = closestNavMenu ? closestNavMenu.dataset.blockId : closestNavItem ? closestNavItem.dataset.blockId : null

      // Check if the element we came from has a block ID
      const fromId = event.fromElement && event.fromElement.dataset.blockId

      // this.logger('Came from:', fromId, 'and went to:', toId)

      // Only set to null if we moved to an el that doesn't have an associated menu block (i.e. we moved outside of the bounds of the megamenu associated elements)
      if (!fromId || !toId) {
        this.currentMegaMenu = null
      }
    }
  }))
})
